import * as React from "react";
import * as yup from "yup";

import { ApolloClient, withApollo } from "../react-apollo";
import { challengeSend } from "../graphql/challenge";
import { Button, Modal } from "../semantic-ui";
import { Formik, Form } from "../formik";
import ArmyInput from "../board/ArmyInput";

const sendChallengeSchema = yup.object().shape({
  senderArmy: yup.string().required(),
  senderColor: yup.string().required(),
});

type Props = {
  client: ApolloClient<any>;
  recipient: any;
  show: boolean;
  onHide?: () => void;
};

class SendChallengeModal extends React.Component<Props> {
  handleSubmit = (values: any) => {
    const variables = {
      senderArmy: values.senderArmy,
      senderColor: values.senderColor === "null" ? null : values.senderColor,
      recipientId: this.props.recipient.id,
    };
    this.props.client
      .mutate({
        mutation: challengeSend,
        variables,
        refetchQueries: ["userQuery"],
      })
      .then(() => {
        if (this.props.onHide) {
          this.props.onHide();
        }
      });
  };

  render() {
    const { recipient, show, onHide } = this.props;
    return (
      <Formik
        initialValues={{ senderArmy: null, senderColor: null }}
        onSubmit={this.handleSubmit}
        validationSchema={sendChallengeSchema}
      >
        <Modal open={show} onClose={onHide} as={Form}>
          <Modal.Header>Challenging {recipient.name}</Modal.Header>
          <Modal.Content>
            <Form.Group inline>
              <label>Which color will you play?</label>
              <Form.Radio label="white" value="white" name="senderColor" />
              <Form.Radio label="black" value="black" name="senderColor" />
              <Form.Radio label="random" value="random" name="senderColor" />
              <Form.Radio
                label="no preference"
                value="null"
                name="senderColor"
              />
            </Form.Group>
            <Form.Field
              label="Which army will you play?"
              name="senderArmy"
              control={ArmyInput}
            />
          </Modal.Content>
          <Modal.Actions>
            <Button primary type="submit">
              Send Challenge
            </Button>
          </Modal.Actions>
        </Modal>
      </Formik>
    );
  }
}

export default withApollo(SendChallengeModal);
